<div class="form-post-wrap">
  <form class="post-form" [formGroup]="postForm">
    <div class="input-group search-input company-search">
      <label class="form-label">Select a company <span style="color: red;">*</span></label>
      <div class="search-input">
        <input formControlName="searchInput" tabindex="-1" class="form-control rounded" placeholder="eg. Entrackr"
          (input)="onSearchChange()" (focus)="showDropdown = true" (blur)="hideDropdown()" />
        <span class="search-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z"
              fill="black" />
          </svg>
        </span>
      </div>
      <div *ngIf="
      postForm.controls['searchInput'].touched &&
      postForm.controls['searchInput'].invalid
    " class="alert alert-danger form-danger error" role="alert">
        <span *ngIf="postForm?.controls['searchInput']?.errors?.required">This is a required field, please enter a
          company name
        </span>
      </div>
      <div *ngIf="showDropdown && companyList.length > 0" class="search-list-wrap" infiniteScroll
        [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" [alwaysCallback]="true" [scrollWindow]="false"
        (scrolled)="onCompanyScroll($event)"  >
        <ul class="search-list">
          <li *ngFor="let item of companyList" class="search-item" (click)="selectDataValue(item)">
            <a>{{ item.name }}</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="input-group search-input">
      <label class="form-label">Select Tag</label>
      <div class="search-input">
        <input formControlName="searchTag" tabindex="-1" class="form-control rounded" placeholder="Tags" (input)="onSearchChangeTag()"
          (focus)="showTagDropdown = true" (blur)="hideDropdown()" />
        <span class="search-icon">
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M11.8161 10.7955L9.09574 8.07515C9.75068 7.20326 10.1042 6.14199 10.103 5.05152C10.103 2.26613 7.83691 0 5.05152 0C2.26613 0 0 2.26613 0 5.05152C0 7.83691 2.26613 10.103 5.05152 10.103C6.14199 10.1042 7.20326 9.75068 8.07515 9.09574L10.7955 11.8161C10.9332 11.9392 11.1128 12.0049 11.2974 11.9997C11.482 11.9946 11.6577 11.9189 11.7883 11.7883C11.9189 11.6577 11.9946 11.482 11.9997 11.2974C12.0049 11.1128 11.9392 10.9332 11.8161 10.7955ZM1.44329 5.05152C1.44329 4.33788 1.65491 3.64027 2.05139 3.0469C2.44786 2.45353 3.01139 1.99105 3.67071 1.71795C4.33003 1.44485 5.05552 1.3734 5.75545 1.51262C6.45538 1.65185 7.0983 1.9955 7.60292 2.50012C8.10754 3.00474 8.45119 3.64766 8.59042 4.34759C8.72964 5.04752 8.65819 5.77301 8.38509 6.43233C8.11199 7.09165 7.64951 7.65518 7.05614 8.05165C6.46277 8.44813 5.76516 8.65975 5.05152 8.65975C4.09491 8.6586 3.17781 8.27808 2.50138 7.60166C1.82496 6.92523 1.44444 6.00813 1.44329 5.05152Z"
              fill="black" />
          </svg>
        </span>
      </div>
      <div *ngIf="showTagDropdown && tagList.length > 0" class="search-list-wrap"  infiniteScroll
        [infiniteScrollDistance]="1" [infiniteScrollThrottle]="50" [alwaysCallback]="true" [scrollWindow]="false"
        (scrolled)="onTagScroll($event)"  >
        <ul class="search-list">
          <li *ngFor="let tag of tagList" class="search-item" (click)="selectDataValueTag(tag)">
            <a>{{ tag.title }}</a>
          </li>
        </ul>
      </div>
    </div>
    <!-- <div class="input-group selectlist">
      <label class="form-label">Select Tag</label>
      <select class="select form-control rounded" formControlName="hashTag">
        <option>
          <span>Choose one</span>
        </option>
        <option *ngFor="let tag of tagList">{{tag.name}}</option>
      </select>
      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path fill-rule="evenodd" clip-rule="evenodd"
          d="M10.3647 3.89992C10.3198 3.8545 10.2659 3.8179 10.2061 3.79222C10.1463 3.76653 10.0817 3.75227 10.016 3.75025C9.95037 3.74823 9.88494 3.75848 9.82347 3.78042C9.762 3.80237 9.70569 3.83557 9.65778 3.87813L5.99996 7.12725L2.34215 3.87813C2.24535 3.79221 2.11648 3.74624 1.9839 3.75033C1.85132 3.75441 1.72588 3.80822 1.63518 3.89992C1.54448 3.99162 1.49595 4.1137 1.50026 4.23929C1.50458 4.36489 1.56138 4.48372 1.65818 4.56964L5.65798 8.12187C5.75065 8.20419 5.87292 8.25 5.99996 8.25C6.127 8.25 6.24927 8.20419 6.34194 8.12187L10.3417 4.56964C10.3897 4.52711 10.4283 4.47604 10.4554 4.41936C10.4825 4.36268 10.4976 4.30149 10.4997 4.23929C10.5019 4.1771 10.491 4.11511 10.4679 4.05688C10.4447 3.99865 10.4097 3.94531 10.3647 3.89992Z"
          fill="black" />
      </svg>
    </div> -->
    <div class="wrap-textarea">
      <textarea class="form-control textarea" formControlName="content" id="posttextarea" rows="5"
        placeholder="What do you want to talk about"></textarea>
      <div *ngIf="
        postForm.controls['content'].touched &&
        postForm.controls['content'].invalid
      " class="alert alert-danger form-danger error" role="alert">
        <span *ngIf="postForm?.controls['content']?.errors?.maxlength">Please enter only 240 character long Content.
        </span>
        <span *ngIf="postForm?.controls['content']?.errors?.minlength">Please enter a least 20 character long Content.
        </span>
        <span *ngIf="postForm?.controls['content']?.errors?.required">This is a required field.
        </span>
      </div>
      <!-- TODO : This code to be used when we have multiple tags and we need to show them is certain way -->
      <!-- <div class="post-tag" *ngFor="let tag of hashTag.value">
        {{tag}}<button (click)="removeDataValueTag(tag)"> remove </button>
      </div> -->
    </div>
    <div class="bottom-btn-wrap d-flex">
      <div class="form-check form-switch">
        <input class="form-check-input" type="checkbox" id="flexSwitchCheckChecked" formControlName="anonymous">
        <label class="form-check-label" for="flexSwitchCheckChecked">Post anonymously
          <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
              d="M14.2166 10.8333C12.6666 10.8333 11.3666 11.9416 11.0333 13.4166C10.2416 13.075 9.51663 13.1666 8.96663 13.4083C8.62496 11.925 7.32496 10.8333 5.78329 10.8333C3.97496 10.8333 2.49996 12.325 2.49996 14.1666C2.49996 16.0083 3.97496 17.5 5.78329 17.5C7.49996 17.5 8.89996 16.15 9.03329 14.4333C9.31663 14.2333 10.0583 13.8583 10.9666 14.45C11.1166 16.1583 12.5 17.5 14.2166 17.5C16.025 17.5 17.5 16.0083 17.5 14.1666C17.5 12.325 16.025 10.8333 14.2166 10.8333ZM5.78329 16.55C4.48329 16.55 3.44163 15.4833 3.44163 14.1666C3.44163 12.85 4.49163 11.7833 5.78329 11.7833C7.08329 11.7833 8.12496 12.85 8.12496 14.1666C8.12496 15.4833 7.08329 16.55 5.78329 16.55ZM14.2166 16.55C12.9166 16.55 11.875 15.4833 11.875 14.1666C11.875 12.85 12.9166 11.7833 14.2166 11.7833C15.5166 11.7833 16.5666 12.85 16.5666 14.1666C16.5666 15.4833 15.5083 16.55 14.2166 16.55ZM18.3333 8.74998H1.66663V9.99998H18.3333V8.74998ZM12.9416 2.19164C12.7583 1.78331 12.2916 1.56664 11.85 1.70831L9.99996 2.32497L8.14163 1.70831L8.09996 1.69997C7.65829 1.57497 7.19163 1.80831 7.02496 2.23331L4.99996 7.49998H15L12.9666 2.23331L12.9416 2.19164Z"
              fill="#995F00" />
          </svg>
        </label>
      </div>
      <button class="btn btn-darkblue-bg" type="button" [disabled]="!(postForm.valid && selectedCompany?.cin)"
        (click)="submit()">Post
        Now</button>
    </div>
  </form>
</div>
